import React from "react";
import {
    Box,
    Flex,
    Text,
    VStack,
    HStack,
    Divider,
} from "@chakra-ui/react";

import { FaCircle } from "react-icons/fa6";
import { formatNumber } from "../../../utils/DefaultFunction";

const channelIcons = {
    SMS: { icon: FaCircle, color: "#3b82f6" },
    WhatsApp: { icon: FaCircle, color: "#10b981" },
    "Voice (IVR)": { icon: FaCircle, color: "var(--brand-primary)" },
    "In-App Notification": { icon: FaCircle, color: "#8b5cf6" },
    "Push Notification": { icon: FaCircle, color: "#ef4444" },
    Email: { icon: FaCircle, color: "#f59e0b" },
    Unknown: { icon: FaCircle, color: "gray.400" },
};

 const MessageCard = ({ name, count, saving, color, icon: Icon ,bg,borderColor,textColor, customer_currency,customer_country}) => {
    const cur = customer_currency
    if (count === 0) return null; 

    return (
        <Flex
            bg={bg}
            borderRadius="lg"
            border="1px solid"
            borderColor={borderColor}
            p={3}
            justify="space-between"
            align="center"
            mb={3}
        >
            <HStack spacing={3}>
                <Box color={color}>
                    <Icon size={18} />
                </Box>
                <Box>
                    <Text fontWeight="400" fontSize={"sm"}>{name}</Text>
                    <Text fontSize="xs" color={textColor}>
                        {count.toLocaleString()} messages
                    </Text>
                </Box>
            </HStack>

            <Box textAlign="right">
                <Text fontWeight="500" color={textColor}>{cur} {formatNumber(saving,"en-US",true)}</Text>
                <Text fontSize="xs" color={textColor}>
                    
                    {count > 0 ? `${customer_currency} ${(saving / count).toFixed(2)} savings per message` : "-"}
                </Text>
            </Box>
        </Flex>
    );
};

const ChannelsBreakDown = ({ data,customer_currency,customer_country }) => {
    // separate domestic & international from API response
    const domestic = data?.map((ch) => ({
        name: ch.channel_name,
        count: ch.domestic.messages,
        saving: ch.domestic.saving ,
        bg:"#f0fdf4",
        borderColor:"#b9f8cf",
        textColor:"#008236",
       ...(channelIcons[ch.channel_name] || channelIcons["Unknown"]),
    }));

    const international = data?.map((ch) => ({
        name: ch.channel_name,
        count: ch.international.messages,
        saving: ch.international.saving,
        bg:'var(--brand-tint)',
        borderColor:"var(--brand-tint-strong)",
        textColor:"var(--brand-primary-hover)",
        customer_currency:customer_currency,
       ...(channelIcons[ch.channel_name] || channelIcons["Unknown"]),
    }));

    return (
        <VStack align="stretch" spacing={6} >

            <Box>
                <HStack mb={3}>
                    <Box boxSize={4} bg="#10b981" borderRadius="full" />
                    <Text fontWeight="500" color="#016630" fontSize={"sm"}>
                        {customer_country} Domestic Messages
                    </Text>
                </HStack>
                {domestic?.map((msg) => (
                    <MessageCard key={`domestic-${msg.name}`} customer_currency={customer_currency} customer_country={customer_country} {...msg} />
                ))}
            </Box>

            <Divider />


            <Box>
                <HStack mb={3}>
                    <Box boxSize={4} bg="#3b82f6" borderRadius="full" />
                    <Text fontWeight="500" color="#193cb8" fontSize={"sm"}>
                        International Messages
                    </Text>
                </HStack>
                {international?.map((msg) => (
                    <MessageCard key={`intl-${msg.name}`} {...msg} />
                ))}
            </Box>
        </VStack>
    );
};

export default ChannelsBreakDown;
